import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";

import { ApiGatewayService } from "../../../../common/api-gateway/api-gateway.service";
import { ForgotPasswordFormValue } from "../../../../models";
import { TranslateService } from "../../../../common/translate/translate.service";
import { SnackbarService } from "../../../../common/snackbar/snackbar.service";
import { getAccountName } from "../../../../util";
import { NavigationService } from "../../../../common/navigation/navigation.service";
import { isImpulseErrorHTTPResponse } from "app/common/translate";

@Component({
	selector: "sdp-forgot-password-form",
	templateUrl: "./forgot-password-form.component.html"
})
export class ForgotPasswordFormComponent implements OnInit {
	@Output()
	public showLoadingBar = new EventEmitter<void>();

	@Output()
	public hideLoadingBar = new EventEmitter<void>();

	@Output()
	public showPendingEmail = new EventEmitter<string>();

	public form: FormGroup;
	private accountName = getAccountName();

	constructor(
		private service: ApiGatewayService,
		private formBuilder: FormBuilder,
		private translateService: TranslateService,
		private snackbarService: SnackbarService,
		private navigationService: NavigationService
	) {
		this.form = this.formBuilder.group({
			email: ["", Validators.required],
		});
	}

	public ngOnInit() {
	}

	public async forgotPassword() {
		this.showLoadingBar.next();
		const formValue = <ForgotPasswordFormValue>this.form.getRawValue();
		try {
			await this.service.resendUserInvitation(formValue.email, this.accountName);
			this.showPendingEmail.next(formValue.email);
		} catch (e) {
			// special case, when the backend tells us no such user show the success anyway
			// this should hide information from casual fishing attempts
			if (isImpulseErrorHTTPResponse(e) && e.error.message === "resend.email.no.such.user") {
				this.showPendingEmail.next(formValue.email);
			} else {
				this.snackbarService.open(this.translateService.translate(e));
			}
		} finally {
			this.hideLoadingBar.next();
		}
	}

	public back() {
		this.navigationService.navigate(["/login/login"]);
	}
}
